function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import LoveButton from './loveButton.js';
import FullscreenSocialDownload from './fullscreenSocialDownload.js';
import { utils } from '../utils';
import classNames from 'classnames';
import _ from 'lodash'; // eslint-disable-next-line import/no-unresolved

import shareIcon from '-!svg-react-loader!../assets/images/fullscreen-store/share-store.svg';
import FULLSCREEN_EVENTS from '../constants/fullscreenEvents';

var FullscreenMobileBar = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FullscreenMobileBar, _React$Component);

  function FullscreenMobileBar(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      showShare: false
    };
    _this.sampleInput = {
      love: {
        onClick: function onClick() {},
        text: '1'
      }
    };
    _this.onShareContainerClick = _this.onShareContainerClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = FullscreenMobileBar.prototype;

  _proto.getLoveButton = function getLoveButton() {
    var _this$props = this.props,
        styles = _this$props.styles,
        love = _this$props.love;

    var props = _.pick(this.props, ['itemId', 'id', 'item', 'idx', 'styles', 'love', 'hashtag', 'actions']);

    return styles.loveButton ? /*#__PURE__*/React.createElement(LoveButton, _extends({}, props, {
      type: this.props.current.item.type,
      layout: "fullscreen",
      device: "mobile",
      showCounter: true,
      actions: {
        eventsListener: this.props.actions.eventsListener
      }
    }, this.props.current.itemLoveData)) : '';
  };

  _proto.getDownloadButton = function getDownloadButton() {
    var _this$props2 = this.props,
        current = _this$props2.current,
        styles = _this$props2.styles,
        additionalNavbarElement = _this$props2.additionalNavbarElement,
        customDownloadUrl = _this$props2.customDownloadUrl;
    var hasAdditionalNavbarElement = typeof additionalNavbarElement === 'function';
    return /*#__PURE__*/React.createElement(FullscreenSocialDownload, {
      layout: "fullscreen",
      device: "mobile",
      hasAdditionalNavbarElement: hasAdditionalNavbarElement,
      current: current,
      styles: styles,
      customDownloadUrl: customDownloadUrl,
      actions: {
        eventsListener: this.props.actions.eventsListener
      }
    });
  };

  _proto.getAdditionalNavbarElement = function getAdditionalNavbarElement() {
    var additionalNavbarElement = this.props.additionalNavbarElement;

    try {
      if (additionalNavbarElement) {
        return additionalNavbarElement(_objectSpread(_objectSpread({}, this.props), {}, {
          styleParams: this.props.styles
        }));
      } else {
        return false;
      }
    } catch (e) {
      console.error('Could not get additional navbar element', e);
    }
  };

  _proto.getShareContainer = function getShareContainer() {
    var shareButton = this.props.styles.allowSocial ? /*#__PURE__*/React.createElement("button", {
      className: "pro-fullscreen-share-icon",
      onClick: this.onShareContainerClick
    }, shareIcon()) : // <i className='progallery-svg-font-icons-share-store pro-fullscreen-share-icon' onClick={() => this.props.actions.toggleShareScreen()}/>
    false;
    return /*#__PURE__*/React.createElement("div", {
      className: "fullscreen-social"
    }, this.getDownloadButton(), this.getAdditionalNavbarElement(), this.getLoveButton(), shareButton);
  };

  _proto.onShareContainerClick = function onShareContainerClick() {
    if (this.props.shouldUseNewSocialSharePopup) {
      var _this$props3, _this$props3$current, _this$props3$current$, _this$props3$current$2, _this$props3$current$3, _this$props4, _this$props4$current, _this$props4$current$, _this$props4$current$2, _this$props5, _this$props5$current, _this$props5$current$;

      this.props.actions.eventsListener(FULLSCREEN_EVENTS.SOCIAL_SHARE_BUTTON_CLICKED, _objectSpread(_objectSpread({
        showSocialSharePopup: true
      }, this.props), {}, {
        title: ((_this$props3 = this.props) == null ? void 0 : (_this$props3$current = _this$props3.current) == null ? void 0 : (_this$props3$current$ = _this$props3$current.item) == null ? void 0 : (_this$props3$current$2 = _this$props3$current$.dto) == null ? void 0 : (_this$props3$current$3 = _this$props3$current$2.metaData) == null ? void 0 : _this$props3$current$3.title) || '',
        directShareLink: ((_this$props4 = this.props) == null ? void 0 : (_this$props4$current = _this$props4.current) == null ? void 0 : (_this$props4$current$ = _this$props4$current.item) == null ? void 0 : (_this$props4$current$2 = _this$props4$current$.dto) == null ? void 0 : _this$props4$current$2.directShareLink) || '',
        createUrl: ((_this$props5 = this.props) == null ? void 0 : (_this$props5$current = _this$props5.current) == null ? void 0 : (_this$props5$current$ = _this$props5$current.item) == null ? void 0 : _this$props5$current$.createUrl) || undefined
      }));
    } else {
      this.props.actions.toggleShareScreen();
    }
  };

  _proto.getTopMobileBar = function getTopMobileBar() {
    var _this2 = this;

    var mobileTopClassNames = classNames('fullscreen-mobile-bar', 'fullscreen-mobile-top', 'pro-fullscreen-store', 'fixed-items', {
      share: this.state.showShare
    });
    var url = this.props.homeGalleryPageUrl;
    return /*#__PURE__*/React.createElement("div", {
      className: mobileTopClassNames
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
      href: url,
      "data-cancel-link": "true"
    }, /*#__PURE__*/React.createElement("button", {
      className: "fullscreen-close progallery-svg-font-icons-back",
      onClick: function onClick() {
        var eventData = {
          itemIdx: _this2.props.current.idx
        };

        _this2.props.actions.eventsListener(FULLSCREEN_EVENTS.CLOSE_FULLSCREEN, eventData);
      }
    })), this.getShareContainer()));
  };

  _proto.render = function render() {
    var mobileBars = [];

    if (utils.isSmallScreen()) {
      mobileBars[0] = this.getTopMobileBar();
      mobileBars[1] = false;
    }

    var res = this.props.isFirst ? mobileBars[0] || false : mobileBars[1] || false;
    return res;
  };

  return FullscreenMobileBar;
}(React.Component);

export default FullscreenMobileBar;